<script>
export default
{
    name: 'mv-menu',
}
</script>

<template>
<ul id="side" class="nav navbar-nav side-nav">

    <li class="side-top">
        <slot></slot>
    </li>


    <li>
      <a class="accordion-toggle" data-target="#settings" data-toggle="collapse" data-parent="#side">
          <icon name="cogs"></icon>
          <span class="link-text">{{ $t('MENU.SETTINGS') }}</span>
      </a>

      <ul id="settings" class="collapse nav navbar-nav nav-submenu">
          <mv-menu-item target="/" :text="$t('MENU.SETTINGS')" icon="dashboard" exact></mv-menu-item>
          <mv-menu-item target="/users" :text="$t('MENU.USERS')" icon="user"></mv-menu-item>
          <mv-menu-item target="/postcategories" :text="$t('MENU.POST_CATEGORIES')" icon="object-group"></mv-menu-item>
      </ul>
    </li>

    <li>
        <a class="accordion-toggle" data-target="#cities" data-toggle="collapse" data-parent="#side">
            <icon name="map-marker"></icon>
            <span class="link-text">{{ $t('MENU.PLACES') }}</span>
        </a>

       <ul id="cities" class="collapse nav navbar-nav nav-submenu">
            <mv-menu-item target="/places" :text="$t('MENU.PLACES')" icon="map-marker"></mv-menu-item>
            <mv-menu-item target="/cities" :text="$t('MENU.CITIES')" icon="building"></mv-menu-item>
       </ul>
    </li>

    <mv-menu-item target="/artists" :text="$t('MENU.ARTISTS')" icon="music"></mv-menu-item>

    <li>
      <a class="accordion-toggle" data-target="#programs" data-toggle="collapse" data-parent="#side">
          <icon name="tasks"></icon>
          <span class="link-text">{{ $t('MENU.PROGRAMS') }}</span>
      </a>
      <ul id="programs" class="collapse nav navbar-nav nav-submenu">
        <mv-menu-item target="/programs" :text="$t('MENU.PROGRAMS')" icon="tasks"></mv-menu-item>
        <mv-menu-item target="/programcategories" :text="$t('MENU.PROGRAMCATEGORIES')" icon="file-text"></mv-menu-item>
      </ul>
    </li>

    <mv-menu-item target="/tickets" :text="$t('MENU.TICKETS')" icon="ticket"></mv-menu-item>

    <mv-menu-item target="/menus" :text="$t('MENU.MENUS')" icon="compass"></mv-menu-item>

    <li>
        <a class="accordion-toggle" data-target="#catalog" data-toggle="collapse" data-parent="#side">
            <icon name="map"></icon>
            <span class="link-text">{{ $t('MENU.CONTENT') }}</span>
        </a>

        <ul id="catalog" class="collapse nav navbar-nav nav-submenu">
            <!-- <mv-menu-item target="/media" :text="$t('MENU.MEDIA')" icon="picture-o"></mv-menu-item> -->
            <mv-menu-item target="/news" :text="$t('MENU.NEWS')" icon="newspaper-o"></mv-menu-item>
            <mv-menu-item target="/supporters" :text="$t('MENU.SUPPORTERS')" icon="handshake-o"></mv-menu-item>
            <mv-menu-item target="/mainpage" text="Fő oldal" icon="object-group"></mv-menu-item>
            <mv-menu-item target="/mainpageimages" text="Fő oldal képek" icon="image"></mv-menu-item>
            <mv-menu-item target="/posts" :text="$t('MENU.INFO')" icon="file-text"></mv-menu-item>
            <mv-menu-item target="/pages" :text="$t('MENU.PAGES')" icon="file-text"></mv-menu-item>
            <mv-menu-item target="/guides" :text="$t('MENU.GUIDES')" icon="tasks"></mv-menu-item>
            <mv-menu-item target="/subscribers" :text="$t('MENU.SUBSCRIBERS')" icon="user"></mv-menu-item>
        </ul>
    </li>

    <li>
        <a class="accordion-toggle" data-target="#wishlists" data-toggle="collapse" data-parent="#side">
            <icon name="star"></icon>
            <span class="link-text">{{ $t('MENU.WISHLISTS') }}</span>
        </a>

       <ul id="wishlists" class="collapse nav navbar-nav nav-submenu">
            <mv-menu-item target="/wishlists" :text="$t('MENU.WISHLISTS')" icon="star"></mv-menu-item>
            <mv-menu-item target="/wishlistcategories" :text="$t('MENU.CATEGORIES')" icon="object-group"></mv-menu-item>
       </ul>
    </li>

    <mv-menu-item target="/recommendations" :text="$t('MENU.RECOMMENDATIONS')" icon="file-text"></mv-menu-item>

    <mv-menu-item target="/forms" :text="$t('MENU.FORMS')" icon="file-text"></mv-menu-item>

    <li>
        <a class="accordion-toggle" data-target="#buses" data-toggle="collapse" data-parent="#side">
            <icon name="ticket"></icon>
            <span class="link-text">{{ $t('MENU.BUSES') }}</span>
        </a>

        <ul id="buses" class="collapse nav navbar-nav nav-submenu">
            <mv-menu-item target="/buses" :text="$t('MENU.BUSES')" icon="bus"></mv-menu-item>
            <mv-menu-item target="/trackers" :text="$t('MENU.TRACKERS')" icon="ticket"></mv-menu-item>
            <mv-menu-item target="/trackermap" :text="$t('MENU.TRACKERMAP')" icon="map"></mv-menu-item>
            <mv-menu-item target="/routes" :text="$t('MENU.ROUTES')" icon="strikethrough"></mv-menu-item>
            <mv-menu-item target="/stations" :text="$t('MENU.STATIONS')" icon="compass"></mv-menu-item>
            <mv-menu-item target="/timetable" :text="$t('MENU.TIMETABLE')" icon="compass"></mv-menu-item>
        </ul>
    </li>

    <mv-menu-item target="/sitenotifications" :text="$t('MENU.SITENOTIFICATIONS')" icon="exclamation"></mv-menu-item>
    <mv-menu-item target="/notifications" :text="$t('MENU.NOTIFICATIONS')" icon="wrench"></mv-menu-item>

</ul>
</template>

<style lang="scss">
.side-nav {
    z-index: 999;
    left: 0;
    top: 50px;

    border-radius: 0;
    border: none;
    overflow: auto;
    transition: all .5s ease;

    padding-top: 1em;
    padding-bottom: 4em;

    a {
        transition: all .4s ease;
    }

    .panel {
        border: none;
        border-radius: 0;
    }

    .accordion-toggle {
        cursor: pointer;
    }

    .navbar-nav {
        margin: 0;
    }

    .side-top {
        text-align: center;
        width: 100%;
        display: block;
        padding-bottom: 1em;
    }
}

@media (min-width:768px) {

    .side-nav {
        position: fixed;
        height: 100vh;
        width: 3em;

        li > a {
            display: block;
            width: 3em;
        }
    }

}

@media (min-width:1200px) {

    .side-nav {
        position: fixed;
        height: 100vh;
        width: 225px;

        li > a {
            display: block;
            width: 225px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/Menu.vue